import TitleHeader from '@/components/TitleHeader/TitleHeader.vue';
import StoreModuleMixin from '@/mixins/StoreModuleMixin';
import { ChartersRequestModel } from '@/modules/ChartersRequestModule/ChartersRequestForm/ChartersRequestForm.types';

import ChartersRequestForm from '@/modules/ChartersRequestModule/ChartersRequestForm/ChartersRequestForm.vue';
import {
  ChartersRequestModuleState,
  SUBMIT_FORM
} from '@/modules/ChartersRequestModule/ChartersRequestModule.store';
import { ChartersRequestViewModel } from '@/modules/ChartersRequestModule/ChartersRequestModule.types';
import { SegmentElement, SegmentTrackEvents } from '@/plugins/utm/SegmentElement';

import { getComponentProps } from '@/utils/vueUtils';
import { getFormPayload } from '@/utils/commonUtils';
import {Component, Mixins, Prop, Watch} from 'vue-property-decorator';
import RecaptchaMixin from '@/forms/FormElements/Mixins/RecaptchaMixin';
import Cookies from 'js-cookie';

@Component({
  components: {
    ChartersRequestForm,
    TitleHeader,
  },
  props: getComponentProps<ChartersRequestViewModel>({
    NumberOfGuestsOptions: [{
        Value: "1",
        Text: "1"
    }],
    ExpectedTravelDateOptions: [{
      Value: "1",
      Text: "1"
    }],
    TypeId: 1,
    ThankYou: "<p>Thank you</p>",
    Title: "Title",
    Text: "Text",
  }),
})

export default class ChartersRequestModule extends Mixins(StoreModuleMixin, RecaptchaMixin) {
  state!: ChartersRequestModuleState;
  postForm: (model: ChartersRequestModel) => void = this.getAction(SUBMIT_FORM);

  formName = '';
  submitPayload: any = {};
  submitIdentifyPayload = {};

  @Prop() readonly p!: ChartersRequestViewModel;

  @Watch('state.IsSubmitted')
  isSubmittedChanged() {
    this.submitPayload.transaction_id = this.state.transaction_id
    SegmentElement.sendEvent(SegmentTrackEvents.formSubmitted, this.submitPayload)
  }

  async submitForm(model: ChartersRequestModel) {
    if (this.p.TypeId !== 1 && model.NumberOfGuestsAffinity) {
      model.NumberOfGuests = model.NumberOfGuestsAffinity
      delete model.NumberOfGuestsAffinity;
    }
    model.RecaptchaResponse = await this.getRecaptchaToken()
    SegmentElement.sendEvent('formSubmissionAttempted', this.submitPayload)
    const { Code, Number } = model.Phone;
    this.submitIdentifyPayload = {
      ...(model.Person.Title && {title: model.Person.Title}),
      first_name: model.Person.FirstName,
      last_name: model.Person.LastName,
      email: model.Person.Email,
      phone: `+${Code}${Number}`,
    }

    var serverPayload = {
      ...this.submitPayload,
      ...this.submitIdentifyPayload,
      locale: SegmentElement.getLocale(),
      ...(!SegmentElement.getIsLanding() && { previous_page_name: SegmentElement.getPrevPageName() }),
      page_name: SegmentElement.getPageName(),
      ...(Cookies.get('_fbc') && { fbclid: Cookies.get('_fbc').split('.')[3] }),
      ...(Cookies.get('email_md5') && { email_md5: Cookies.get('email_md5') }),
      ...(Cookies.get('_uetmsclkid') && { mscklid: Cookies.get('_uetmsclkid').split('_uet')[1] }),
      ...(Cookies.get('_gcl_aw') && { gclid: Cookies.get('_gcl_aw').split('.')[2] }),
    }

    this.postForm({ ...model, AnalyticsPayload: JSON.stringify(serverPayload)});
  }
  
  get titleHeaderData() {
    return {
      Title: this.p.Title,
      Text: this.p.Text,
      Link: {
        Title: null,
        Link: null,
      },
      Center: false,
    };
  }
  created() {
    this.siteKey = '6LeRy_4eAAAAAFAdd7s_F1PChLUq4j6A90H5Ppyw';
  }
  mounted() {
    this.formName = this.p.TypeId === 1 ? 'ChartersRequestForm' : 'AffinityRequestForm';
    this.submitPayload = getFormPayload(this.formName, this.$attrs.contentLinkId);
    SegmentElement.sendEvent('formViewed', {...this.submitPayload, nonInteraction: 1});
  }
}
